import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormLanguageTextField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { LangDefinition, TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { langDefinition } from '../../../config/app.config';
import { LocalizePipe } from '../../../pipes/standalone/localize.pipe';
import { MatError, MatFormField, MatHint, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatOption, MatSelect, MatSelectTrigger } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { GetFormControlPipe } from '../../../pipes/get-form-control.pipe';

@Component({
    selector: 'localetext-field-component',
    templateUrl: './localetext-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LocalizePipe, FormsModule, GetFormControlPipe, MatButtonToggle, MatButtonToggleGroup, MatError, MatFormField, MatHint, MatIcon, MatInput, MatLabel, MatOption, MatPrefix, MatSelect, MatSelectTrigger, ReactiveFormsModule, TranslocoPipe]
})
export class DtypeLocaleTextFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormLanguageTextField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    /** LangDefinition as defined in transloco.module */
    availableLangs: LangDefinition[];

    selectedLang: string;

    constructor(private translocoService: TranslocoService) { }

    ngOnInit() {
        this.availableLangs = this.translocoService.getAvailableLangs().map(lang => langDefinition[lang]);
        this.selectedLang = this.translocoService.getActiveLang();

        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

}
